
<div class="mainContainer">
  <div class="logoContainer">
    <div class="ImageContainer" [ngClass]="{
          'default-logo': this.ImageURL == null || this.ImageURL.trim() == ''
        }">
      <img *ngIf="!(this.ImageURL == null || this.ImageURL.trim() == '')" [src]="ImageURL" alt="Logo"
        class="inner-image" />
    </div>
    <div class="divider"></div>
    <div class="snapshot-study-name-area">
      <div class="snapshot-study-header-name" (click)="showSnapshotDropdown()" DocumentClick (DocumentClicked)="this.showSnapshotDropdownVal=false">
        
        <div class="snapshot-label">{{ categoryLabel }}</div>
        <div class="brand-block-wrapper">
          <span class="brand-block">{{ activeSectionLabel }}</span>
          <span class="study-open-icon"></span>
        </div>
      </div>      
      <div class="SnapshotListArea category-dropdown-panel" *ngIf="showSnapshotDropdownVal" id="snapshot-dropdown">

        <!-- Category sections (landing layout): Enterprise | gap | Business Lines -->
        <div class="Dropdown-popup-Across" *ngIf="useCategoryNavDropdown && categoryNavGroups.length > 0">
          <div class="Dropdown-popup-Across-scroll">
            <ng-container *ngFor="let group of categoryNavGroups; let gi = index">
              <div class="category-bucket-gap" *ngIf="gi > 0"></div>
              <div
                *ngFor="let tile of group.items"
                class="Across-section-container category-section-row"
                [title]="tile.displayLabel"
                [ngClass]="{ active: isCategoryTileActive(tile) }"
                (click)="navigateCategoryTile(tile)">
                <span [title]="tile.displayLabel">{{ tile.displayLabel }}</span>
              </div>
            </ng-container>
          </div>
        </div>

        <!-- Legacy fallback (snapshot types + sections) -->
        <div class="Dropdown-popup-Across" *ngIf="!useCategoryNavDropdown && hasLegacyAcrossDropdown">
          <div class="Dropdown-popup-Across-scroll">
            <div class="Across-container" *ngFor="let item of AcrossDropdown">
                 <div title="{{item.snapshotType_name}}" class="Across-container-snapshotType-txt">
                      <span title="{{item.snapshotType_name}}"> {{item.snapshotType_name}}</span>
                 </div>
                 <div class="Across-container-section-block" *ngFor="let section of item.section">
                    <div class="Across-section-container" *ngIf="section.subsection[0].subsection_name=='NA'" title="{{section.section_name}}"
                    [ngClass]="{ 'active': isLegacySectionActive(item, section) }" (click)="navigateSnapshot(item, section, { subsection_name: 'NA' })">
                        <span title="{{section.section_name}}"> {{section.section_name}}</span> 
                    </div>
                    <div class="Across-subsection-container-block" *ngIf="section.subsection[0].subsection_name!='NA'">
                        <div class="Across-section-container2"  title="{{section.section_name}}">
                            <span title="{{section.section_name}}"> {{section.section_name}}</span> 
                        </div>
                        <div class="Across-subsection-container" 
                         title="{{section.section_name}}" *ngFor="let subsection of section.subsection"
                         [ngClass]="{ 'active': isLegacySectionActive(item, section, subsection) }">
                            <span title="{{subsection.subsection_name}}" (click)="navigateSnapshot(item, section, subsection)"> - {{subsection.subsection_name}}</span> 
                        </div>
                    </div>
                </div>
            </div>
         </div>
        </div>

      </div>
    </div>
  </div>
</div>
